import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill"]


export default /*#__PURE__*/_defineComponent({
  __name: 'ArrowIcon',
  props: {
    color: { default: `currentColor` },
    title: { default: `` }
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    viewBox: "0 0 6.3 11.3",
    xmlns: "http://www.w3.org/2000/svg",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit(`click`)))
  }, [
    _createElementVNode("title", null, _toDisplayString(_ctx.title), 1),
    _createElementVNode("path", {
      d: "M0,10.6,5.6,5l.7.7L.7,11.3ZM0,.7.7,0,6.3,5.7l-.7.6Z",
      fill: _ctx.color
    }, null, 8, _hoisted_1)
  ]))
}
}

})